module.exports = "mutation ($id: ID!, $data: ShopContractUpdate!) {\n  ShopContractUpdate(id: $id, data: $data) {\n    id\n  }\n}\n"